import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1314f148"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col laptop:flex-row laptop:items-start laptop:px-[5%] overflow-hidden" }
const _hoisted_2 = { class: "flex flex-row pt-10 pb-5 overflow-scroll gap-8 items-start laptop:flex-col laptop:sticky laptop:top-[60px] laptop:overflow-hidden laptop:items-center laptop:p-[2%] laptop:min-h-[100vh] laptop:justify-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[20px]" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[20px]" }, null, -1))
const _hoisted_5 = { class: "flex flex-col py-10 px-[7%] justify-center laptop:sticky laptop:top-[60px] laptop:h-[100vh] laptop:w-[400px]" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col flex-grow items-center laptop:items-end py-5 my-auto tablet:slide-from-right"
}
const _hoisted_7 = { class: "flex flex-col gap-5 w-11/12 tablet:w-3/4 justify-end items-end my-auto" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "p-5 bg-opacity-40 flex-grow text-left laptop:px-10 rounded" }
const _hoisted_10 = { class: "text-black" }
const _hoisted_11 = { class: "text-gray-400" }
const _hoisted_12 = {
  key: 1,
  class: "flex items-center laptop:w-3/4 justify-center h-full align-middle items-center my-auto"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex w-1/2 justify-center" }, "V tomto roce momentálně nejsou k dispozici žádné výsledky", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-[200px] bg-white w-full" }, null, -1))

import {onMounted, ref, withDefaults} from 'vue'
  import {Competition} from "@/interfaces/interfaces";
  import {CompetitionType} from "@/interfaces/enums"
  import CustomButton from "@/components/Base/CustomButton.vue";
  import zavody from "../../../public/data/zavody";


  
export default /*#__PURE__*/_defineComponent({
  props: {
    compType: { default: CompetitionType.spolecky },
    year: { default: new Date().getFullYear }
  },
  setup(__props: any) {

const props = __props as { compType: CompetitionType, year: number }



  // function getButtonBgColor(btnYear: number){
  //   let color = ''
  //   switch(props.compType as CompetitionType){
  //     case CompetitionType.spolecky : { color = 'bg-greenLight'} break
  //     case CompetitionType.jednotlivci : {color = 'bg-orangeLight'} break
  //     case CompetitionType.esg :  {color = 'bg-blueLight'} break
  //   }
  //   if(btnYear === props.year){
  //      color = color.slice(0,-5)
  //   }
  //   return color
  // }


  const activeYear = ref<number>(new Date().getFullYear())

  function getCompetitionType(type: CompetitionType){
    switch (type){
      case CompetitionType.jednotlivci : return 'jednotlivkyň'
      case CompetitionType.spolecky : return 'společných skladeb'
      case CompetitionType.esg : return 'esg'
    }
  }

  function getColor(): string{
    switch(props.compType){
      case CompetitionType.jednotlivci : return 'orange'
      case CompetitionType.spolecky : return 'green'
      case CompetitionType.esg : return 'blue'
    }
  }

  const arrayRange = (start: number, stop: number, step: number) =>
      Array.from(
          { length: (stop - start) / step + 1 },
          (value, index) => start + index * step
      );

  const yearsToRender =  arrayRange(new Date().getFullYear(), 2023, -1)

  const competitionsToRender = ref<Competition[]>([])

  function getCompetitionsToRender(){
    competitionsToRender.value = zavody.filter((comp) => comp.date.endsWith(activeYear.value.toString())  && comp.results != null && comp.results !== '' && comp.type === props.compType)
  }

  onMounted(() => {
    getCompetitionsToRender()
  })

function handleClickYear(year: number) {
  activeYear.value = year
  getCompetitionsToRender()
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(yearsToRender), (item) => {
          return (_openBlock(), _createBlock(CustomButton, {
            value: item.toString(),
            key: item,
            "bg-color": item === activeYear.value ? 'bg-' + getColor() : 'bg-' + getColor() + 'Light',
            class: _normalizeClass(["rounded-2xl font-semibold hover:text-white",  __props.compType === _unref(CompetitionType).jednotlivci ? 'hover:bg-orange' : (__props.compType === _unref(CompetitionType).spolecky ? 'hover:bg-green' : 'hover:bg-blue')]),
            "text-color": item === activeYear.value ? 'text-white' : 'text-' + getColor() + 'Dark',
            onClick: ($event: any) => (handleClickYear(item))
          }, null, 8, ["value", "bg-color", "class", "text-color", "onClick"]))
        }), 128)),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", {
          class: _normalizeClass(["text-4xl uppercase font-bold laptop:w-[20px] laptop:overflow-visible laptop:text-left laptop:text-5xl laptop:leading-[70px]", __props.compType === _unref(CompetitionType).jednotlivci ? 'text-orange' : (__props.compType === _unref(CompetitionType).spolecky ? 'text-green' : 'text-blue')])
        }, " Závody " + _toDisplayString(getCompetitionType(__props.compType)) + " " + _toDisplayString(activeYear.value), 3)
      ]),
      (competitionsToRender.value.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(competitionsToRender.value, (item) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: item.name,
                  class: _normalizeClass(["flex flex-col tablet:flex-row w-[100%] bg-opacity-40 group tablet:hover:bg-opacity-60 tablet:transition-all", 'bg-' + getColor() + 'Light']),
                  href: '/PDFs/vysledky/' + item.results,
                  target: "_blank"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h2", {
                      class: _normalizeClass(["text-lg tablet:text-xl font-semibold", 'text-' + getColor() + 'Dark'])
                    }, _toDisplayString(item.name), 3),
                    _createElementVNode("h3", _hoisted_10, _toDisplayString(item.club), 1),
                    _createElementVNode("h4", _hoisted_11, _toDisplayString(item.date), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["p-3 tablet:p-5 flex flex-col justify-center tablet:group-hover:px-7 tablet:transition-all tablet:duration-200 rounded-b tablet:rounded-r", ['bg-' + getColor() + 'Light', 'hover:bg-' + getColor(), {'group-hover:bg-green' : props.compType === _unref(CompetitionType).spolecky, 'group-hover:bg-orange' : props.compType === _unref(CompetitionType).jednotlivci, 'group-hover:bg-blue' : props.compType === _unref(CompetitionType).esg }]])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["underline text-[16px] transition duration-200 tablet:group-hover:text-white", 'text-' + getColor()])
                    }, "výsledky", 2)
                  ], 2)
                ], 10, _hoisted_8))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
    ]),
    _hoisted_15
  ], 64))
}
}

})